const actions = {
  SERVICE_CATEGORY_ADD_BEGIN: 'SERVICE_CATEGORY_ADD_BEGIN',
  SERVICE_CATEGORY_ADD_SUCCESS: 'SERVICE_CATEGORY_ADD_SUCCESS',
  SERVICE_CATEGORY_ADD_ERR: 'SERVICE_CATEGORY_ADD_ERR',
  
  SERVICE_CATEGORIES_READ_BEGIN: 'SERVICE_CATEGORIES_READ_BEGIN',
  SERVICE_CATEGORIES_READ_SUCCESS: 'SERVICE_CATEGORIES_READ_SUCCESS',
  SERVICE_CATEGORIES_READ_ERR: 'SERVICE_CATEGORIES_READ_ERR',

  SERVICE_CATEGORY_UPDATE_BEGIN: 'SERVICE_CATEGORY_UPDATE_BEGIN',
  SERVICE_CATEGORY_UPDATE_SUCCESS: 'SERVICE_CATEGORY_UPDATE_SUCCESS',
  SERVICE_CATEGORY_UPDATE_ERR: 'SERVICE_CATEGORY_UPDATE_ERR',

  SERVICE_CATEGORY_DELETE_BEGIN: 'SERVICE_CATEGORY_DELETE_BEGIN',
  SERVICE_CATEGORY_DELETE_SUCCESS: 'SERVICE_CATEGORY_DELETE_SUCCESS',
  SERVICE_CATEGORY_DELETE_ERR: 'SERVICE_CATEGORY_DELETE_ERR',

  SERVICE_CATEGORY_READ_BEGIN: 'SERVICE_CATEGORY_READ_BEGIN',
  SERVICE_CATEGORY_READ_SUCCESS: 'SERVICE_CATEGORY_READ_SUCCESS',
  SERVICE_CATEGORY_READ_ERR: 'SERVICE_CATEGORY_READ_ERR',

  SERVICE_CATEGORY_UPLOAD_BEGIN: 'SERVICE_CATEGORY_UPLOAD_BEGIN',
  SERVICE_CATEGORY_UPLOAD_SUCCESS: 'SERVICE_CATEGORY_UPLOAD_SUCCESS',
  SERVICE_CATEGORY_UPLOAD_ERR: 'SERVICE_CATEGORY_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.SERVICE_CATEGORIES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.SERVICE_CATEGORIES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.SERVICE_CATEGORY_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORY_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.SERVICE_CATEGORY_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.SERVICE_CATEGORY_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORY_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.SERVICE_CATEGORY_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.SERVICE_CATEGORY_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORY_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.SERVICE_CATEGORY_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.SERVICE_CATEGORY_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORY_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.SERVICE_CATEGORY_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.SERVICE_CATEGORY_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.SERVICE_CATEGORY_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.SERVICE_CATEGORY_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
